<template>
  <section>
    <template v-if="showMode === 'popup'">
      <van-popup
        v-if="config.level === 1 && config.popupType === 2"
        v-model="canPopup"
        :close-on-click-overlay="false"
        :class="['site-notice-img', displayModeClassName]"
        :closeable="config.closeable === 1"
        @closed="close"
      >
        <van-image
          class="notice-img"
          alt="notice-img"
          :src="config.imageUrl"
          @click="goLandUrl()"
        />
      </van-popup>
      <van-popup
        v-else
        v-model="canPopup"
        :close-on-click-overlay="false"
        :class="['site-notice', displayModeClassName]"
        :closeable="config.closeable === 1"
        @closed="close"
      >
        <van-image
          v-if="config.showIcon === 1"
          class="notice-icon"
          :src="require(`@/assets/images/common/logo.png`)"
        />
        <p class="title">{{ config.title }}</p>
        <p class="desc">{{ config.content }}</p>
      </van-popup>
    </template>
    <template v-if="showMode === 'banner'">
      <van-notice-bar
        left-icon="volume-o"
        :text="config.content"
        :class="['banner-notice', displayModeClassName]"
        mode="closeable"
      />
      <div class="placeholder"></div>
    </template>
  </section>
</template>

<script>
  import dayjs from 'dayjs'
  import { mapState, mapGetters } from 'vuex'
  import { PQ, Message } from '@/utils/priorityQueue'
  import { pagePopupShow, pagePopupClick } from '@/pages/marketingFirebase.js'
  import { isMsaWebView } from '@/utils/msa'
  import { fetchDetailConfig } from '@/api/games'
  import { jumpToPage } from '@/utils/utils'

  const popup_id = 'cloud-control-popup'

  export default {
    name: 'dialog-tips',
    data() {
      return {
        showPopup: false,
        showMode: null,
        config: {},
        romoteConfigDatas: null,
        canPopup: false,
      }
    },
    computed: {
      ...mapState(['gameName', 'region', 'isDesktop', 'source']),
      ...mapGetters(['displayModeClassName']),
    },
    watch: {
      showPopup(val) {
        if (val) {
          PQ.enqueue({
            id: popup_id,
            priority: 1,
          })
        }
      },
      canPopup: function (val) {
        if (val && this.config.level === 1) {
          // 应急云控图片弹窗曝光埋点
          pagePopupShow({
            page: this.gameName,
            list_id: this.config.id,
            popup_type: 'cloud_control',
          })
        }
      },
    },
    mounted() {
      // msa屏蔽云控弹窗
      if (isMsaWebView()) return
      this.getConfigInfo('pageload')
      Message.receive((res) => {
        const { id } = res || {}

        if (id === popup_id) {
          PQ.open(popup_id)
          this.canPopup = true
        }
      })
    },
    methods: {
      close() {
        this.$emit('closeTips')
        this.showPopup = false
        PQ.close(popup_id)
        PQ.dequeue(popup_id)
      },
      getConfigInfo(callType, selectedId, channelId, showLoading) {
        return new Promise((resolve, reject) => {
          const self = this
          async function getConfigDatas() {
            if (callType !== 'submit' && self.romoteConfigDatas) {
              return self.romoteConfigDatas || []
            } else {
              try {
                const romoteDatas = await fetchDetailConfig(
                  {
                    game: self.gameName,
                    country: self.region,
                    source: self.source,
                  },
                  {
                    showLoading,
                    cacheFlag: false,
                  }
                )
                const { emergencies = [] } = romoteDatas || {}
                self.romoteConfigDatas = emergencies
                return emergencies
              } catch (e) {
                reject(e)
              }
            }
          }
          getConfigDatas().then((res) => {
            if (res && res.length > 0) {
              this.config = res[0]
              const curTs = dayjs().unix()
              const {
                triggerBeginTime,
                triggerEndTime,
                level,
                eventType,
                landUrl,
                triggerEvent,
                eventKey,
              } = res[0]
              let { popupType } = res[0]
              //level 1：P0 2：P1
              //popupType 1：文字 2：图片
              //事件等级为P1时没有popupType，默认为文字
              if (!popupType) {
                popupType = 1
                this.config.popupType = 1
              }
              if (
                landUrl &&
                (level * 1 === 2 || (level * 1 === 1 && popupType * 1 === 1))
              ) {
                // 如果配置了要跳转的url，且（事件等级为P1）或者（事件等级为P0，弹窗类型为文字）时直接跳转
                jumpToPage(landUrl)
                return
              }
              // 页面加载时，事件类型为game并且pageload时就触发事件
              if (
                callType === 'pageload' &&
                triggerEvent * 1 === 1 &&
                eventType * 1 === 1
              ) {
                if (
                  curTs > triggerBeginTime * 1 &&
                  curTs < triggerEndTime * 1
                ) {
                  this.showPopup = true
                  // 当事件级别为P0（level=1）时弹框，其他为banner通知栏
                  if (level * 1 === 1) {
                    this.showMode = 'popup'
                    resolve(false) // false 为不可下单
                  } else {
                    this.showMode = 'banner'
                    resolve(true) // true 为可下单
                  }
                }
              }
              // 点击sku时
              if (callType === 'clickSku' && eventType * 1 === 2) {
                // 配置的事件类型为sku，事件触发为点击sku时，对那些sku id生效
                if (
                  triggerEvent * 1 === 2 &&
                  eventKey &&
                  eventKey.split(',').includes(selectedId + '')
                ) {
                  resolve(
                    this.showPopupFn(triggerBeginTime, triggerEndTime, curTs)
                  )
                }
              }

              // 点击channel时
              if (callType === 'clickChannel' && eventType * 1 === 3) {
                // 配置的事件类型为channel，事件触发为点击channel时，对那些channel id生效
                if (
                  triggerEvent * 1 === 2 &&
                  eventKey &&
                  eventKey.split(',').includes(selectedId + '')
                ) {
                  resolve(
                    this.showPopupFn(triggerBeginTime, triggerEndTime, curTs)
                  )
                }
              }

              // 点击提交按钮时
              if (callType === 'submit' && triggerEvent * 1 === 3) {
                // 配置的事件类型为sku，事件触发为点击submit时，对那些sku id生效
                if (
                  eventType * 1 === 2 &&
                  eventKey &&
                  eventKey.split(',').includes(selectedId + '')
                ) {
                  resolve(
                    this.showPopupFn(triggerBeginTime, triggerEndTime, curTs)
                  )
                }
                // 配置的事件类型为channel，事件触发为点击submit时，对那些channel id生效
                if (
                  eventType * 1 === 3 &&
                  eventKey &&
                  eventKey.split(',').includes(channelId + '')
                ) {
                  resolve(
                    this.showPopupFn(triggerBeginTime, triggerEndTime, curTs)
                  )
                }
              }
              resolve(true)
            } else {
              resolve(true)
            }
          })
        })
      },
      showPopupFn(triggerBeginTime, triggerEndTime, curTs) {
        if (curTs > triggerBeginTime * 1 && curTs < triggerEndTime * 1) {
          this.showPopup = true
          this.showMode = 'popup'
          return false
        }
        return true
      },
      goLandUrl() {
        const landUrl = this.config.landUrl
        if (landUrl) {
          pagePopupClick({
            page: this.gameName,
            list_id: this.config.id,
            popup_type: 'cloud_control',
          })
          jumpToPage(landUrl)
        }
      },
    },
  }
</script>
<style lang="scss">
  .banner-notice {
    height: 180px;
    &.display-desktop {
      height: 80px;
    }
  }
  .site-notice {
    width: 80%;
    height: auto;
    background: #252525;
    border-radius: 20px;
    color: #fff;
    text-align: center;
    padding: 76px;
    box-sizing: border-box;
    z-index: 9999 !important;
    .notice-icon {
      width: 160px;
    }
    .title {
      text-align: center;
      font-size: 60px;
      padding: 30px 0;
      box-sizing: border-box;
    }
    .desc {
      font-size: 36px;
      line-height: 50px;
    }
    &.display-desktop {
      width: 460px;
      padding: 36px;
      .notice-icon {
        width: 60px;
      }
      .title {
        font-size: 28px;
        padding: 20px 0;
      }
      .desc {
        font-size: 20px;
        line-height: 30px;
      }
    }
  }
  .site-notice-img {
    width: 80%;
    height: auto;
    background: transparent;
    border-radius: 20px;
    text-align: center;
    box-sizing: border-box;
    z-index: 9999 !important;
    .notice-img {
      width: 100%;
      display: block;
    }
    &.display-desktop {
      width: 460px;
      .notice-img {
        width: 100%;
        display: block;
      }
    }
  }
</style>
